<template>
  <div class="app-container">
    <div>
      <p>{{ $t("common.download_template_excel") }}</p>
      <i class="fa fa-download" aria-hidden="true"></i>
      <!-- <a href="../static/dataimport/import_customer_sample.xlsx" download="import_customer_sample">Download</a> -->
      <a @click="exportExcelFile">{{ $t("common.exportFileExcel") }}</a>
    </div>
    <upload-excel-component
      :on-success="handleSuccess"
      :before-upload="beforeUpload"
    />
    <b-table
      striped
      hover
      small
      :items="resultImportList"
      :fields="resultImportList_fields"
      class="mt-3"
      outlined
    >
      <template #head()="scope">
        <div>{{ $t(scope.label) }}</div>
      </template>
      <template slot="statusImport" slot-scope="row">
        <!-- {{row}} -->
        <p style="color:green" v-if="row.item.statusImport == 'PASS'">
          {{ row.item.statusImport }}
        </p>
        <p style="color:red" v-else>{{ row.item.statusImport }}</p>
        <p />
      </template>
    </b-table>

    <div class="box-footer">
      <button
        id="cmdCancel"
        type="button"
        class="btn btn-labeled btn-danger"
        @click="CancelCustomerList"
        style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
      >
        <span class="btn-label">
          <i class="fa fa-mail-reply"></i>
        </span>
        {{ $t("common.back") }}
      </button>
    </div>

    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import UploadExcelComponent from "@/components/UploadExcel/index.vue";
// import utils from '@/lib/utils'
import { mapGetters, mapActions } from "vuex";
import Enum from "../../../enum/enum";
import XLSX from "xlsx";

export default {
  name: "CustomerImportExcel",
  components: {
    UploadExcelComponent,
    loading: Loading
  },
  data() {
    return {
      tableData: [],
      tableHeader: [],
      hdBackground: "background-color: #4b646f;border:1px solid white;", //00a65a
      isLoading: false,
      resultImportList: [], // Result import
      resultImportList_fields: [
        {
          key: "username",
          label: "customer.username",
          sortable: true,
          class: "text-center"
        },
        {
          key: "statusImport",
          label: "common.status",
          sortable: true,
          class: "text-center"
        },
        {
          key: "errorDetail",
          label: "common.error",
          sortable: true,
          class: "text-center"
        }
      ],

      validateElement: {}
    };
  },
  watch: {},
  computed: {
    ...mapGetters([])
  },
  methods: {
    ...mapActions([
      "IMPORT_CUSTOMER"
    ]),
    beforeUpload(file) {
      this.isLoading = true;
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (isLt1M) {
        return true;
      }

      this.$message({
        message: "Please do not upload files larger than 1m in size.",
        type: "warning"
      });

      this.isLoading = false;
      return false;
    },

    handleSuccess({ results, header }) {
      this.tableData = results;
      let data = {
        headers: header,
        dataImport: results,
        domain: Enum.domain
      };
      // init empty
      this.resultImportList = [];
      this.IMPORT_CUSTOMER(data)
        .then(
          function(res) {
            res.dataResult.forEach(v => {
              let dataPass = {
                username: v.username,
                statusImport: v.result,
                errorDetail: v.error
              };
              this.resultImportList.push(dataPass);
            });
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            let dataError = {
              username: "Unknown",
              statusImport: "FAIL",
              errorDetail: "Unknown"
            };
            // console.log(JSON.stringify(dataError));
            this.resultImportList.push(dataError);
            this.isLoading = false;
          }.bind(this)
        );

      this.tableHeader = header;
    },
    CancelCustomerList: function() {
      this.$router.push({
        name: "CustomerList"
      });
    },
    exportExcelFile: function() {
      let data_list = [];
      let json_data = [
        {
          email: "sample_user10@test.com",
          "Họ và Tên": "Nguyen Van MrB",
          "Địa Chỉ": "109",
          "Ngày Sinh": "1992-04-01",
          "Điện Thoại": "0338019210",
          "Giới Tính": "Nam"
        },
        {
          email: "sample_user11@test.com",
          "Họ và Tên": "Nguyen Van MrC",
          "Địa Chỉ": "110",
          "Ngày Sinh": "1992-01-25",
          "Điện Thoại": "0338019211",
          "Giới Tính": "Nam"
        }
      ];

      data_list = json_data;
      // export json to Worksheet of Excel
      // only array possible
      var ReceiptFile = XLSX.utils.json_to_sheet(data_list);
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, ReceiptFile, "ImportCustomerSample"); // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, 'pokemons')

      // export Excel file
      XLSX.writeFile(wb, "import_customer_sample.xlsx"); // name of the file is 'book.xlsx'
    }
  },
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/views/Customer/CustomerImportExcel.vue